<template>
  <el-drawer :visible.sync="drawer" id="checkInfo" custom-class="el-drawer" size="840px">
    <div slot="title">
      <el-row>
        <el-col :span="20">
          <div>举报ID</div>
          <div>
            <span class="vertical_middle">啦啦啦</span>
            <img
              :src="require('@/assets/img/platform/pla_'+'JD'+'.png')"
              alt
              class="edit_icon vertical_middle"
            />
          </div>
        </el-col>
        <el-col :span="4">
          <img
            src="../../../assets/img/other/await_icon.png"
            alt
            class="await_icon2 vertical_middle"
          />
          <span class="vertical_middle">待初审</span>
        </el-col>
      </el-row>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="举报信息处理" name="first">
        <!-- 举报信息 -->


        <commonReportInfo></commonReportInfo>
        <!-- 处理信息 -->
        <div class="drawer-subtitle_common margin_top20">
          <span class="drawer-subtitle-text">处理信息</span>
        </div>
        <el-card class="margin_top20">
          <!-- 内部 -->
          <el-form label-width="100px" v-if="logintype!=='HCM'&&logintype!=='HCMSUB'">
            <el-form-item label="处理结果:" :required="true">
              <el-select
                filterable
                v-model="dealResultcheck"
                @change="changedealResult"
                size="small"
              >
                <el-option
                  v-for="(item,i) in dealResult"
                  :key="i+'a533'"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="处理截图:">
              <uploadPic @getpic="getpic"></uploadPic>
            </el-form-item>
            <el-form-item label="处理说明:">
              <el-input type="textarea" placeholder="请输入说明，请保持在200字以内。" class="common_textarea"   maxlength="200"></el-input>
            </el-form-item>
          </el-form>
          <!-- 外部 -->
          <el-form label-width="100px" v-else>
            <el-form-item label="处理方式:">xxx</el-form-item>
            <el-form-item label="处理截图:">
              <viewer :src="checkInfo.photo" class="viewer-see">
                <img :src="checkInfo.photo" class='common_img'/>
              </viewer>
            </el-form-item>
            <el-form-item label="处理说明:">xxxx</el-form-item>
            <el-form-item label="处理人:">xxxx</el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="处理时间节点" name="second">
        <el-timeline>
          <el-timeline-item timestamp="2018/4/12" placement="top">
            <div>
              <div>王小虎 提交于 2018/4/12 20:46</div>
              <div>状态：嘻嘻嘻嘻</div>
            </div>
          </el-timeline-item>
          <el-timeline-item timestamp="2018/4/3" placement="top">
            <div>
              <div>王小虎 提交于 2018/4/12 20:46</div>
              <div>状态：嘻嘻嘻嘻</div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>
<script>
import { getLoginType } from "@/libs/until";
import uploadPic from "@/views/CreditScore/common/uploadPic";
import commonReportInfo from '@/views/CreditScore/common/commonReportInfo'
export default {
  data() {
    return {
      drawer: false,
      checkInfo: {
        checkBtn: null,
        photo: ["https://brm.qmipr.com/ex-img/zhiwen-status.png"]
      },
      activeName: "first",
      logintype: getLoginType(),
      dealResult: ["通知店铺整改", "知识产权投诉"],
      dealResultcheck: ""
    };
  },
  components: { uploadPic,commonReportInfo },
  methods: {
    handleClick() {},
    changedealResult() {},
    getpic(){}
  }
};
</script>
<style lang="scss">
#checkInfo {
  .await_icon2 {
    margin-right: 5px;
  }
  .edit_icon {
    margin-left: 5px;
  }
  .drawer-subtitle_common {
    margin: 0;
  }
  .info_header {
    margin: 20px 0;
  }
  .margin_top20 {
    margin-top: 20px;
  }
  .check_textarea {
    width: 392px;
    .el-textarea__inner {
      height: 90px;
    }
  }
}
</style>
